// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindDynamicBoolean, TagKindDynamicBoolean } from "../schema";
import { serialize_KindDynamicBoolean_internal, deserialize_KindDynamicBoolean_internal } from "./KindDynamicBoolean";

export function serialize_TagKindDynamicBoolean_internal(value: TagKindDynamicBoolean): unknown {
  return ((value: { discriminator: KindDynamicBoolean; id: bigint; kind: string }): unknown => {
    return {
      discriminator: ((value: KindDynamicBoolean): unknown => {
        return serialize_KindDynamicBoolean_internal(value);
      })(value["discriminator"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      kind: ((value: string): unknown => {
        return value;
      })(value["kind"]),
    };
  })(value);
}
export function serialize_TagKindDynamicBoolean(obj: TagKindDynamicBoolean): string {
  return renderJsonWithNumbersAsBigint(serialize_TagKindDynamicBoolean_internal(obj));
}
export function deserialize_TagKindDynamicBoolean_internal(value: unknown): ParserResult<TagKindDynamicBoolean> {
  return ((
    value: unknown,
  ): ParserResult<{
    discriminator: KindDynamicBoolean;
    id: bigint;
    kind: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "discriminator")) {
      return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
    }
    const parsed_discriminator = ((): ParserResult<KindDynamicBoolean> => {
      return ((value: unknown): ParserResult<KindDynamicBoolean> => {
        return deserialize_KindDynamicBoolean_internal(value);
      })(value["discriminator"]);
    })();
    if (!parsed_discriminator.success) {
      return { success: false, reason: parsed_discriminator.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
  })(value);
}
export function deserialize_TagKindDynamicBoolean(str: string): ParserResult<TagKindDynamicBoolean> {
  return deserialize_TagKindDynamicBoolean_internal(parseJsonWithNumbersAsBigint(str));
}
